import { useMemo } from 'react'

export default function useCachedUniqueList(data: string[]): string[] {
  return useMemo(() => {
    const unique = [...new Set(data)] as string[]
    return unique
  }, [data])
}
